export const DashboardActionTypes = {
    SET_CUSTOMER_COUNTS: 'SET_CUSTOMER_COUNTS',
    SET_LETTER_COUNTS: 'SET_LETTER_COUNTS',
    SET_REFERRAL_COUNTS: 'SET_REFERRAL_COUNTS',
    SET_ROLE_COUNTS: 'SET_ROLE_COUNTS',
    SET_FRANCHISE_COUNTS: 'SET_FRANCHISE_COUNTS',
};